import React, { useEffect } from "react";
import { Table, Avatar, Tag } from "antd";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { dashboardPMSApis } from "../../../api/DashboardPMS";

interface TeamStatusData {
  key: string;
  name: string;
  initials: string;
  color: string;
  taskOverdue: number;
  taskToday: number;
  taskAllOpen: number;
  issueOverdue: number;
  issueToday: number;
  issueAllOpen: number;
}

// const mockData: TeamStatusData[] = [
//   {
//     key: "1",
//     name: "bharath.devar...",
//     initials: "BH",
//     color: "#f56a00",
//     taskOverdue: 48,
//     taskToday: 2,
//     taskAllOpen: 111,
//     issueOverdue: 1,
//     issueToday: 0,
//     issueAllOpen: 1,
//   },
//   {
//     key: "2",
//     name: "Naveen Kethava...",
//     initials: "NK",
//     color: "#7265e6",
//     taskOverdue: 0,
//     taskToday: 1,
//     taskAllOpen: 2,
//     issueOverdue: 0,
//     issueToday: 0,
//     issueAllOpen: 0,
//   },
//   {
//     key: "3",
//     name: "Priyanka Vemula",
//     initials: "PV",
//     color: "#00a2ae",
//     taskOverdue: 0,
//     taskToday: 1,
//     taskAllOpen: 3,
//     issueOverdue: 0,
//     issueToday: 0,
//     issueAllOpen: 0,
//   },
// ];

const TeamStatusTable: React.FC<any> = ({ id }: any) => {
  const [mockData, setMockData] = React.useState<TeamStatusData[]>([]);
  const fetchTeamStaus = async () => {
    try {
      const apiResponse: ApiResponse =
        await dashboardPMSApis.fetchTeamStatusDashboard(id, "teamStatus");
      const { data, status } = apiResponse;
      setTimeout(() => {
        if (status && data) {
          setMockData(data);
        } else {
          setMockData([]);
        }
      }, 800);
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    {
      title: "Users",
      dataIndex: "name",
      key: "name",
      render: (_: string, record: TeamStatusData) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar style={{ backgroundColor: record.color, fontSize: 12 }}>
            {record.initials}
          </Avatar>
          <span>{record.name}</span>
        </div>
      ),
    },
    {
      title: <span style={{ color: "red" }}>Overdue</span>,
      dataIndex: "taskOverdue",
      key: "taskOverdue",
      render: (value: number) => (
        <span style={{ color: value > 0 ? "red" : undefined }}>{value}</span>
      ),
    },
    {
      title: "Today's",
      dataIndex: "taskToday",
      key: "taskToday",
    },
    {
      title: "All Open",
      dataIndex: "taskAllOpen",
      key: "taskAllOpen",
    },
  ];

  useEffect(() => {
    fetchTeamStaus();
  }, [id]);

  return (
    <div style={{ position: "relative", height: "100%" }}>
      <Table
        columns={columns}
        dataSource={mockData}
        pagination={false}
        size="middle"
        bordered={false}
        scroll={{ y: 250 }}
        components={{
          header: {
            cell: (props: any) => (
              <th
                {...props}
                style={{
                  ...props.style,
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fafafa",
                  zIndex: 1,
                  borderBottom: "1px solid #f0f0f0",
                }}
              />
            ),
          },
        }}
        style={{
          height: "100%",
        }}
      />
    </div>
  );
};

export default TeamStatusTable;
